var _excluded = ["children", "id", "alert", "message", "resendAction", "resendLabel", "dismiss", "onDismiss", "dismissIcon", "onClick", "onExit", "exiting"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useEffect, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import Icon from '../Icon';
import { CheckIcon, CrossIcon, ReloadIcon } from '../Icons';
import { ToastWrapper, StyledCheckIcon, ToastMessage, RemoveButton, StyledResendButton, StyledIcon } from './style';
var Toast = function Toast(props) {
  var children = props.children,
    id = props.id,
    alert = props.alert,
    message = props.message,
    resendAction = props.resendAction,
    resendLabel = props.resendLabel,
    dismiss = props.dismiss,
    onDismiss = props.onDismiss,
    dismissIcon = props.dismissIcon,
    onClick = props.onClick,
    onExit = props.onExit,
    exiting = props.exiting,
    rest = _objectWithoutProperties(props, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hidden = _useState2[0],
    setHidden = _useState2[1];
  var onClose = useCallback(function (e) {
    setHidden(true);
    if (onDismiss) {
      onDismiss(e);
    }
  }, [onDismiss]);
  var handleAnimationEnd = function handleAnimationEnd() {
    if (onExit) {
      onExit(id);
    }
  };
  useEffect(function () {
    var timeout;
    if (dismiss > 0) {
      timeout = setTimeout(onClose, dismiss * 1000);
    }
    return function () {
      return clearTimeout(timeout);
    };
  }, [dismiss, onClose]);
  return /*#__PURE__*/React.createElement(ToastWrapper, _extends({
    alert: alert,
    id: "toast_".concat(id),
    "data-testid": "".concat(id, "-toast"),
    onClick: onClick,
    exiting: exiting || hidden,
    onAnimationEnd: handleAnimationEnd
  }, rest), alert === 'success' ? /*#__PURE__*/React.createElement(StyledCheckIcon, {
    as: CheckIcon
  }) : null, /*#__PURE__*/React.createElement(ToastMessage, {
    dismiss: dismiss,
    alert: alert
  }, children || message, resendAction && /*#__PURE__*/React.createElement(StyledResendButton, {
    variant: "ghost",
    stretch: "auto",
    onClick: resendAction,
    id: "resend_".concat(id)
  }, /*#__PURE__*/React.createElement(StyledIcon, null, /*#__PURE__*/React.createElement(Icon, {
    as: ReloadIcon,
    size: "sz16"
  })), resendLabel)), dismiss === 0 && !onClick || dismissIcon ? /*#__PURE__*/React.createElement(RemoveButton, {
    variant: "ghost",
    stretch: "auto",
    onClick: onClose,
    id: "close_".concat(id),
    "data-testid": "".concat(id, "-remove-button")
  }, /*#__PURE__*/React.createElement(Icon, {
    as: CrossIcon,
    color: "black",
    size: "sz32"
  })) : null);
};
Toast.defaultProps = {
  children: null,
  alert: 'info',
  message: 'message',
  dismiss: 0,
  exiting: false,
  onClick: null,
  onExit: null,
  onDismiss: null,
  resendAction: null,
  resendLabel: 'Retry',
  dismissIcon: false
};
Toast.propTypes = {
  children: PropTypes.node,
  id: PropTypes.string.isRequired,
  alert: PropTypes.oneOf(['success', 'warning', 'info', 'error']),
  message: PropTypes.string,
  /**
   * number of seconds to autodismiss the Toast. 0 disables
   */
  dismiss: PropTypes.number,
  /**
   * sets the fadeout animation
   */
  exiting: PropTypes.bool,
  /**
   * Click on the toast itself
   */
  onClick: PropTypes.func,
  /**
   * Callback to remove current Toast element from parent component
   */
  onExit: PropTypes.func,
  /**
   * Displays retry button
   */
  resendAction: PropTypes.func,
  resendLabel: PropTypes.string,
  /**
   * Click close button
   */
  onDismiss: PropTypes.func,
  dismissIcon: PropTypes.bool
};
Toast.displayName = 'Toast';
export default Toast;